export const GET_ADMIN_DATA = 'GET_ADMIN_DATA';
export const ADMIN_ERROR = 'ADMIN_ERROR';
export const HANDLE_ERROR = 'HANDLE_ERROR';